import ButtonView from '../../../home24-shared/wishlist/buttonView';
import { register } from '../../core/bootstrapper';

register('category-new search-new article article-new', function() {
  new ButtonView();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/wishlist/wishlistBootstrap.js
 **/